import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { Tag } from '../../shared/models/tag.model';
import { LogService } from 'src/app/shared/services/log.service';

@Injectable({ providedIn: 'root' })
export class TagService {
  apiHost: string = environment.apiHost;
  TagArr: Tag[] = [];
  constructor(
    private http: HttpClient,
    private router: Router,
    private logService: LogService
  ) {}

  async loadAllTags() {
    this.TagArr = await this.getAllTags();
    if (this.TagArr == null) this.TagArr = [];
    this.TagArr = this.TagArr.sort((a, b) => {
      if (a.name < b.name) return -1;
      if (a.name > b.name) return 1;
      return 0;
    });
  }

  async loadTags() {
    this.TagArr = await this.getActiveTags();
    if (this.TagArr == null) this.TagArr = [];
    this.TagArr = this.TagArr.sort((a, b) => {
      if (a.name < b.name) return -1;
      if (a.name > b.name) return 1;
      return 0;
    });
  }  

  getActiveTags(): Promise<Tag[]> {
    let promise = new Promise<Tag[]>((resolve, reject) => {
      return this.http
        .get<Tag[]>(this.apiHost + '/Tag/GetAllActive')
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Get Active Tags', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  getAllTags(): Promise<Tag[]> {
    let promise = new Promise<Tag[]>((resolve, reject) => {
      return this.http
        .get<Tag[]>(this.apiHost + '/Tag/getall')
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Get All Tags', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  addTag(Tag: Tag): Promise<Tag> {
    let promise = new Promise<Tag>((resolve, reject) => {
      return this.http
        .post<Tag>(this.apiHost + '/Tag/add', Tag)
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Add Tag', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  saveTag(Tag: Tag): Promise<Tag> {
    let promise = new Promise<Tag>((resolve, reject) => {
      return this.http
        .post<Tag>(this.apiHost + '/Tag/update', Tag)
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Update Tag', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  deleteTag(TagId: number): Promise<Tag> {
    let promise = new Promise<Tag>((resolve, reject) => {
      return this.http
        .post<Tag>(
          this.apiHost + '/Tag/delete?TagId=' + TagId.toString(),
          null
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Delete Service Tag', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  undeleteTag(TagId: number): Promise<Tag> {
    let promise = new Promise<Tag>((resolve, reject) => {
      return this.http
        .post<Tag>(
          this.apiHost + '/Tag/undelete?TagId=' + TagId.toString(),
          null
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Undelete Service Tag', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  getMemberTags(MemberId: number): Promise<Tag[]> {
    let promise = new Promise<Tag[]>((resolve, reject) => {
      return this.http
        .post<Tag[]>(
          this.apiHost + '/Tag/getmembertags?MemberId=' + MemberId.toString(),
          null
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Get Member Tags', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  addTagToMember(MemberId: number, TagId: number): Promise<Tag[]> {
    let promise = new Promise<Tag[]>((resolve, reject) => {
      return this.http
        .post<Tag[]>(
          this.apiHost + '/Tag/AddTagToMember?MemberId=' + MemberId.toString() + '&TagId=' + TagId,
          null
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Add Tag to Member', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }  

  removeTagFromMember(MemberId: number, TagId: number): Promise<Tag[]> {
    let promise = new Promise<Tag[]>((resolve, reject) => {
      return this.http
        .post<Tag[]>(
          this.apiHost + '/Tag/RemoveTagFromMember?MemberId=' + MemberId.toString() + '&TagId=' + TagId,
          null
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Remove Tag from Member', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }  
}
